import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import { hasClientAccessToPersonalization } from 'utils/clientSettings';
import useSiteConfigSelector from 'components/useSiteConfigSelector';
import useSiteCopySelector from 'components/useSiteCopySelector';

const usePersonalization = () => {
  const [featuresSiteConfig] = useSiteConfigSelector(['Features']);
  const [accountSiteCopy] = useSiteCopySelector(['account']);
  const clientDetails = useSelector(makeSelectClientDetails());

  const isPersonalizationEnabled = hasClientAccessToPersonalization({
    featuresSiteConfig,
    clientDetails,
  });

  // Get emailSubscription (and customconsent if defined) from pageCopy.subscription
  const subscriptionArray = _get(accountSiteCopy, 'pageCopy.subscription', []);

  // Get email preferences options from emailPreferencesModal
  const emailPreferencesOptions = _get(
    accountSiteCopy,
    'pageCopy.emailPreferencesModal.options',
    [],
  );

  // Filter personalization based on feature access
  const filteredEmailPreferencesOptions = emailPreferencesOptions.filter(
    item => {
      if (item.value === 'personalization') {
        return isPersonalizationEnabled;
      }
      return true;
    },
  );

  // If emailSubscription has default=true, select all available email preferences
  const emailSubscriptionOption = subscriptionArray.find(
    item => item.value === 'emailSubscription',
  );

  const initialSubscriptionValues = emailSubscriptionOption?.default
    ? filteredEmailPreferencesOptions.map(opt => opt.value).filter(Boolean)
    : [];

  return {
    isPersonalizationEnabled,
    emailSubscriptionOption,
    emailPreferencesOptions: filteredEmailPreferencesOptions,
    initialSubscriptionValues,
  };
};

export default usePersonalization;
